import { Tooltip as Tp } from 'react-tooltip'

import { Container } from './styles'

type TooltipProps = {
  id: string
  text: string
  children: React.ReactNode
  maxWidth?: string
  hidden?: boolean
  offset?: number
}

export const Tooltip = ({
  id,
  text,
  children,
  maxWidth,
  hidden,
  offset = 10,
}: TooltipProps) => {
  return (
    <Container
      data-tooltip-id={id}
      data-tooltip-html={text}
      data-tooltip-offset={offset}
      data-tooltip-hidden={hidden}
    >
      {children}
      <Tp
        id={id}
        className="tooltip"
        style={{ maxWidth: maxWidth || 'initial' }}
      />
    </Container>
  )
}
